require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ENDPOINT = {
  FREE: 'https://api.microlink.io',
  PRO: 'https://pro.microlink.io'
};

var pickBy = function pickBy(obj) {
  Object.keys(obj).forEach(function (key) {
    return obj[key] == null && delete obj[key];
  });
  return obj;
};

var factory = function factory(_ref) {
  var VERSION = _ref.VERSION,
      MicrolinkError = _ref.MicrolinkError,
      isUrlHttp = _ref.isUrlHttp,
      stringify = _ref.stringify,
      got = _ref.got,
      flatten = _ref.flatten;

  var assertUrl = function assertUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!isUrlHttp(url)) {
      var message = "The `url` as `".concat(url, "` is not valid. Ensure it has protocol (http or https) and hostname.");
      throw new MicrolinkError({
        url: url,
        data: {
          url: message
        },
        status: 'fail',
        code: 'EINVALURLCLIENT',
        message: message,
        more: 'https://microlink.io/docs/api/api-parameters/url'
      });
    }
  };

  var mapRules = function mapRules(rules) {
    if (typeof rules !== 'object') return;
    var flatRules = flatten(rules);
    return Object.keys(flatRules).reduce(function (acc, key) {
      return _objectSpread({}, acc, _defineProperty({}, "data.".concat(key), flatRules[key]));
    }, {});
  };

  var fetchFromApi = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apiUrl) {
      var opts,
          response,
          body,
          rawMessage,
          _err$response,
          _response,
          statusCode,
          rawBody,
          headers,
          _response$url,
          uri,
          _body,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.prev = 1;
              _context.next = 4;
              return got(apiUrl, opts);

            case 4:
              response = _context.sent;
              body = response.body;
              return _context.abrupt("return", _objectSpread({}, body, {
                response: response
              }));

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              rawMessage = _context.t0.message, _err$response = _context.t0.response, _response = _err$response === void 0 ? {} : _err$response;
              statusCode = _response.statusCode, rawBody = _response.body, headers = _response.headers, _response$url = _response.url, uri = _response$url === void 0 ? apiUrl : _response$url;
              _body = rawBody ? typeof rawBody === 'string' || Buffer.isBuffer(rawBody) ? JSON.parse(rawBody) : rawBody : {
                message: rawMessage,
                status: 'fail'
              };
              throw MicrolinkError(_objectSpread({}, _body, {
                message: _body.message,
                url: uri,
                statusCode: statusCode,
                headers: headers
              }));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function fetchFromApi(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getApiUrl = function getApiUrl(url) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref3.data,
        apiKey = _ref3.apiKey,
        endpoint = _ref3.endpoint,
        retry = _ref3.retry,
        cache = _ref3.cache,
        opts = _objectWithoutProperties(_ref3, ["data", "apiKey", "endpoint", "retry", "cache"]);

    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref4$responseType = _ref4.responseType,
        responseType = _ref4$responseType === void 0 ? 'json' : _ref4$responseType,
        gotOpts = _objectWithoutProperties(_ref4, ["responseType"]);

    var isPro = !!apiKey;
    var apiEndpoint = endpoint || ENDPOINT[isPro ? 'PRO' : 'FREE'];
    var apiUrl = "".concat(apiEndpoint, "?").concat(stringify(_objectSpread({
      url: url
    }, mapRules(data), {}, flatten(pickBy(opts)))));
    var headers = isPro ? {
      'x-api-key': apiKey
    } : {};
    return [apiUrl, _objectSpread({}, gotOpts, {
      responseType: responseType,
      cache: cache,
      retry: retry,
      headers: headers,
      timeout: false
    })];
  };

  var createMql = function createMql(gotOpts) {
    return /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
        var opts,
            _getApiUrl,
            _getApiUrl2,
            apiUrl,
            fetchOpts,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                assertUrl(url);
                _getApiUrl = getApiUrl(url, opts, gotOpts), _getApiUrl2 = _slicedToArray(_getApiUrl, 2), apiUrl = _getApiUrl2[0], fetchOpts = _getApiUrl2[1];
                return _context2.abrupt("return", fetchFromApi(apiUrl, fetchOpts));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
  };

  var mql = createMql();
  mql.MicrolinkError = MicrolinkError;
  mql.getApiUrl = getApiUrl;
  mql.fetchFromApi = fetchFromApi;
  mql.mapRules = mapRules;
  mql.version = VERSION;
  mql.stream = got.stream;
  mql.buffer = createMql({
    responseType: 'buffer'
  });
  return mql;
};

module.exports = factory;